import Image from 'next/image'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import LazyLoad from 'react-lazyload'
import InnovativeSection from '~/components/LandingPage/InnovativeSection'
import JourneySection from '~/components/LandingPage/JourneySection'
import TeamSection from '~/components/LandingPage/TeamSection'
import LayoutLandingPage from '~/components/Layout/LayoutLandingPage'
import RequestDemoForm from '~/components/RequestDemo/RequestDemoForm'
import { FCC } from '~/core/@types/global'
import { ICONS } from '~/core/constants/resources'
import { TypographyH1 } from '~/core/ui/Heading'
import { useClient } from '~/lib/hooks/use-is-client'

const DemoListItem: FCC<{ className?: string }> = ({
  children,
  className = ''
}) => {
  return (
    <li
      className={`flex px-4 py-2 items-center bg-white rounded-md gap-[10px] w-fit ${className}`}>
      <Image
        src={ICONS.checked}
        loading="lazy"
        width={20}
        height={20}
        alt="checked"
      />
      <div className="text-lg">{children}</div>
    </li>
  )
}

const RequestDemoContainer: FC = () => {
  const { t } = useTranslation()
  const { isClient } = useClient()

  return (
    <LayoutLandingPage isHidRequestDemoButton={false}>
      <div className="bg-[#EBECFF] pt-10 desktop:pb-20 tablet:pb-[130px] tablet:pt-20">
        <div className="relative mx-auto flex max-w-[1216px] gap-y-10 px-4 flex-col pb-16 tablet:pb-0 desktop:grid tablet:grid desktop:grid-cols-[1fr_592px] tablet:grid-cols-[1fr_450px] tablet:flex-row tablet:gap-x-[100px]">
          <Image
            src={'/img/feature/lp/cr_vertical_line1.png'}
            width={2}
            height={246}
            alt="cr_vertical_line1"
            className="z-1 absolute left-9 -top-12"
          />
          <Image
            src={'/img/feature/lp/cr_hori_line1.svg'}
            width={472}
            height={0}
            alt="cr_vertical_line1"
            className="z-1 absolute top-10 -left-[76px]"
          />

          <div className="z-10">
            <img
              src={'/img/feature/lp/phone_message.png'}
              loading="lazy"
              width={80}
              height={80}
              alt="phone_message"
            />
            <TypographyH1 className="mb-3 mt-8 font-normal text-[43px] leading-[52px] text-primary-400 tablet:mb-4 tablet:text-[64px] tablet:leading-[64px]">
              {t('request_demo:title')}
            </TypographyH1>
            <div className="text-gray-700 text-[19px] leading-[28px]">
              {t('request_demo:description')}
            </div>
            <Image
              src={'/img/feature/lp/cr_hori_line2.png'}
              loading="lazy"
              width={84}
              height={0}
              alt="cr_hori_line2"
              className="py-9"
            />
            <div className="text-[23px] leading-[36px] mb-[20px] tablet:text-[20px] tablet:leading-[28px]  tablet:text-2xl">
              {t('request_demo:hireforce_gives_you')}
            </div>
            <ul className="grid tablet:mb-8 gap-y-3">
              <DemoListItem>{t('request_demo:feat_key_1')}</DemoListItem>
              <DemoListItem>{t('request_demo:feat_key_2')}</DemoListItem>
              <DemoListItem>{t('request_demo:feat_key_3')}</DemoListItem>
            </ul>
            {/* <div className="rounded border border-gray-100  bg-gray-50 px-4 py-3 text-base tablet:text-lg">
                <Trans
                  i18nKey="request_demo:support_mail"
                  values={{ email: 'support@hireforce.io' }}>
                  <a
                    href={`mailto:support@hireforce.io`}
                    className="font-medium text-gray-800"
                  />
                </Trans>
              </div> */}
          </div>
          <div className="flex-1">
            {isClient ? (
              <RequestDemoForm
                configText={{
                  name: 'Full name',
                  email: 'Email',
                  company: 'Company name',
                  title: 'Title',
                  phone: 'Phone number',
                  country: 'Country',
                  message: 'Message',
                  submit: `${t('request_demo:submit')}`
                }}
                actionUrl="https://api.encharge.io/v1/forms/5e0ad455-dadb-419d-ab70-ecffb4a3db4d/submission/plain"
              />
            ) : null}
          </div>
        </div>
      </div>

      <LazyLoad height={300} once>
        <TeamSection className="my-[164px]" />
      </LazyLoad>

      <LazyLoad height={300} once>
        <InnovativeSection className="my-[164px]" hasRequestForm={true} />
      </LazyLoad>

      <LazyLoad height={300} once>
        <JourneySection
          hideFeatures
          hideTryFreeAction
          isGhostBookDemoBtn={false}
        />
      </LazyLoad>
    </LayoutLandingPage>
  )
}

export default RequestDemoContainer
